import { Component, inject } from '@angular/core';
import { ProjectListBaseComponent } from 'src/app/modals/projects/project-list-base.component';
import { CustomerInfoStore } from 'src/app/stores/customer-info/customer-info.store';

@Component({
  selector: 'ng-casto-customer-info-projects',
  templateUrl: './customer-info-projects.component.html',
})
export class CustomerInfoProjectsComponent extends ProjectListBaseComponent {
  private readonly customerInfoStore = inject(CustomerInfoStore);

  protected override get createProjectButtonId(): string {
    return 'customer-info-create-project';
  }

  protected override afterNavigate(): void {
    this.customerInfoStore.setIsOpen(false);
  }

  protected override afterProjectsChanged(): void {
    this.loadProjects();
  }
}
